import { UpdateEscrowPaymentDataArgs } from 'types/api/arguments/update-escrow-payment-data-args'

export const escrowPaymentDataUpdateArgsToParams = ({
  paymentData,
}: UpdateEscrowPaymentDataArgs) => ({
  payment_data: { ...paymentData },
})
